<label class="heading">{{ heading }}</label><span *ngIf="isRequired" class="required"></span>
<div class="{{ style }}">
    <ng-content></ng-content>
</div>
